<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-container fluid>

      <b-row>
        <b-col class="subtitulos">
          Generación de reporte de Ptis presupuestados por CDXE
        </b-col>
      </b-row>
      <div class="mt-2 col-md-12"></div>


      <validation-observer ref="observer" v-slot="{ handleSubmit }">
        <b-form @submit.stop.prevent="handleSubmit(buscar)">
          <b-row>
            <b-col>
              <b-row>
                <b-col cols="4">
                  <validation-provider name="fcInicioVal" :rules="{ required: true }" v-slot="validationContext">
                    <label>Fecha inicio:<validacion/></label>
                    <b-input-group size="sm" class="mb-2">
                      <b-form-datepicker placeholder="Fecha inicio"
                                         :max="new Date()"
                                         @input="fechaMaxima($event)"
                      ></b-form-datepicker>
                    </b-input-group>
                    <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '"/>
                  </validation-provider>
                </b-col>

                <b-col cols="4">
                  <validation-provider name="fcFinVal" :rules="{ required: true }" v-slot="validationContext">
                    <label>Fecha fin:<validacion/></label>
                    <b-input-group size="sm" class="mb-2">
                      <b-form-datepicker placeholder="Fecha fin"
                                         v-model="filtro.fechaFin"
                                         :max="filtro.fechaInicio.addDays(diasMaximoMes) > new Date() ? new Date(): filtro.fechaInicio.addDays(diasMaximoMes)"
                                         :min="filtro.fechaInicio"
                      ></b-form-datepicker>
                    </b-input-group>
                    <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '"/>
                  </validation-provider>
                </b-col>

              </b-row>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>


      <b-row>
        <b-col>
          <b-row align-v="center" align-h="end">
            <b-col>
              <download-excel
                  v-if="datosTabla.length > 0 && $localStorageService.can('BT_Excel_presu_cdx_m2')"
                  :data="datosTabla"
                  class="btn btn-primary"
                  :fields="fieldsExcel"

                  worksheet="My Worksheet"
                  name="reportePtisFueraCDXE.xls"
              >
                Generar Excel
              </download-excel>
            </b-col>


            <b-col cols="2" align="right">
              <b-button v-b-tooltip.hover title="Generar reporte" variant="outline-success"
                        @click="generar()" :disabled="loader">Generar
              </b-button>
            </b-col>

          </b-row>
        </b-col>
      </b-row>
      <div class="mt-2 col-md-12"></div>

      <b-row>
        <b-col cols="12">
          <b-table
              thead-tr-class="columnas"
              :items="datosTabla"
              :fields="fields"
              :per-page="$registrosPorPaginaTabla"
              :current-page="paginaActual"
              :responsive="true"
              class="parrafos"
     >
            <template v-slot:cell(monto)="row">
              {{ row.item.monto | monedaEntero }}
            </template>
          </b-table>
          <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loader">
            <b-alert v-if="datosTabla!==undefined && datosTabla.length === 0" variant="warning" show>No hay datos
            </b-alert>
          </b-col>
          <b-col v-if="!loader">
            <b-pagination
                v-if="datosTabla !== undefined && datosTabla.length > 10"
                align="center"
                v-model="paginaActual"
                :total-rows="datosTabla.length"
                :per-page="$registrosPorPaginaTabla"
                aria-controls="tabla"
            ></b-pagination>
          </b-col>
        </b-col>
      </b-row>

    </b-container>
  </div>
</template>

<script>

import {required} from "vuelidate/lib/validators";

export default {
  name: "reportePtiPresupuestadoCDXE",
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    diasMaximoMes: null,
    datosTabla: [],
    fields: [],
    paginaActual: 1,
    loader: false,
    filtro: {
      fechaInicio: null,
      fechaFin: null,
    },
    fieldsExcel: {
      "Id Paciente": "idPaciente",
      "Id Pti": "idPti",
      "Nombre del paciente": "nombrePaciente",
      "Clinica": "clinica",
      "Embajador": "embajador",
      "Opcion": "opcionAceptada",
      "Tipo paciente": "fase",
      "Fecha emisión": "tipoPaciente",
      "Fase": "fechaPresupuesto",
      "Monto ($)": "monto",

    }
  }),
  validations: {
    filtro: {
      fechaInicio: {required},
      fechaFin: {required},
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    fechaMaxima(event){
      this.diasMaximoMes = this.$moment(event).daysInMonth();
      this.filtro.fechaInicio = new Date(event);
      this.filtro.fechaFin = null;

    },
    generar() {
      this.loader = true;
      this.datosTabla = [];

      this.$http.post(this.$api + 'reportes/obtenerReportePtisCDXE', this.filtro).then(respuesta => {
        if (respuesta.data.data) {
          this.fields.push({key: "idPaciente", label: "Id Paciente", sortable: true});
          this.fields.push({key: "idPti", label: "Id Pti", sortable: true});
          this.fields.push({key: "nombrePaciente", label: "Nombre", sortable: true});
           this.fields.push({key: "clinica", label: "Clinica", sortable: true});
          this.fields.push({key: "embajador", label: "Embajador", sortable: true});
          this.fields.push({key: "opcionAceptada", label: "Opción", sortable: true});
          this.fields.push({key: "fase", label: "Tipo paciente", sortable: true});
          this.fields.push({key: "tipoPaciente", label: "Fecha emisión", sortable: true});
          this.fields.push({key: "fechaPresupuesto", label: "Fase", sortable: true});
          this.fields.push({key: "monto", label: "Monto ($)", sortable: true});

          this.datosTabla = respuesta.data.data

        }
      }).finally(() => {
        this.loader = false;
        this.paginaActual = 1;
      })
    },
    validateState(name) {
      const {$dirty, $error} = this.$v.filtro[name];
      return $dirty ? !$error : null;
    },
  }
}
</script>

<style scoped>

</style>
